export default "__VITE_ASSET__86df7857__"